// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FiUpload, FiEye, FiCalendar, FiFileText, FiCheckCircle, FiXCircle, FiInbox, FiShield, FiInfo } from "react-icons/fi";
// import { API_BASE_URL, API_DOMAIN } from "../utils/config";
// import "./EmployeeDashboard.css";


// const MedicalCertificate = () => {
//   const [certificates, setCertificates] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const [formData, setFormData] = useState({
//     registrationDate: "",
//     expiryDate: "",
//     document: null,
//   });

//   const userRole = localStorage.getItem("userRole");
//   const employeeData = JSON.parse(localStorage.getItem("employeeData"));
  
//   let userId = "";
//   let userName = "";
//   let isCandidate = userRole === "candidate";

//   if (isCandidate) {
//     userId = localStorage.getItem("candidateId");
//     userName = localStorage.getItem("candidateName");
//   } else {
//     userId = employeeData?.employeeId;
//     userName = employeeData?.name;
//   }

//   const [notifications, setNotifications] = useState([]);

//   useEffect(() => {
//     if (userId && userId !== "undefined" && userId !== "null") {
//       fetchCertificates();
//       fetchNotifications();
//     } else {
//       setError("");
//     }
//   }, [userId]);

//   const fetchCertificates = async () => {
//     try {
//       setLoading(true);
//       if (userId === "undefined" || userId === "null") return;
//       const res = await axios.get(`${API_BASE_URL}/medical-certificates/employee/${userId}`);
//       if (res.data.success) {
//         setCertificates(res.data.data);
//       }
//     } catch (err) {
//       console.error("Fetch certificates error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchNotifications = async () => {
//     try {
//       if (!userId || userId === "undefined" || userId === "null") return;
//       const res = await axios.get(`${API_BASE_URL}/medical-certificates/notifications/${userId}`);
//       if (res.data?.success) {
//         setNotifications(res.data.data);
//       }
//     } catch (err) {
//       // Silently ignore - notifications are non-critical
//       setNotifications([]);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = (e) => {
//     setFormData((prev) => ({ ...prev, document: e.target.files[0] }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!userId || userId === "undefined" || userId === "null") {
//       alert("Session expired or invalid user. Please login again.");
//       return;
//     }
//     if (!formData.registrationDate || !formData.expiryDate || !formData.document) {
//       alert("Please fill all fields and select a document.");
//       return;
//     }

//     // Date validation
//     const registrationDate = new Date(formData.registrationDate);
//     const expiryDate = new Date(formData.expiryDate);
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     // Registration date should be at least 6 months old
//     const sixMonthsAgo = new Date();
//     sixMonthsAgo.setMonth(today.getMonth() - 6);
//     sixMonthsAgo.setHours(0, 0, 0, 0);

//     if (registrationDate > sixMonthsAgo) {
//       setError("Registration dates should be more than 6 months old.");
//       return;
//     }

//     // Expiry date should be in the future
//     if (expiryDate <= today) {
//       setError("Expiry date must be in the future.");
//       return;
//     }

//     // Expiry date should be after registration date
//     if (expiryDate <= registrationDate) {
//       setError("Expiry date must be after registration date.");
//       return;
//     }

//     // Calculate the difference in months
//     const monthsDiff = (expiryDate.getFullYear() - registrationDate.getFullYear()) * 12 +
//                        (expiryDate.getMonth() - registrationDate.getMonth());

//     // Ensure at least 6 months difference
//     if (monthsDiff < 6) {
//       setError("Expiry date must be at least 6 months after registration date.");
//       return;
//     }

//     try {
//       setUploading(true);
//       setError("");
//       setSuccess("");

//       const data = new FormData();
//       if (isCandidate) {
//         data.append("candidateId", userId);
//         data.append("candidateName", userName);
//       } else {
//         data.append("employeeId", userId);
//         data.append("employeeName", userName);
//       }
//       data.append("registrationDate", formData.registrationDate);
//       data.append("expiryDate", formData.expiryDate);
//       data.append("document", formData.document);

//       const res = await axios.post(`${API_BASE_URL}/medical-certificates/upload`, data, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.data.success) {
//         setSuccess("Medical certificate uploaded successfully!");
//         setFormData({ registrationDate: "", expiryDate: "", document: null });
//         fetchCertificates();
//       }
//     } catch (err) {
//       console.error("Upload error:", err);
//       setError(err.response?.data?.message || "Failed to upload certificate.");
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="emp-dash__container">
//       {/* Dashboard Header */}
//       <div className="emp-dash__header">
//         <div>
//           <h1 className="emp-dash__greeting">
//             Medical <span>Certificate</span>
//           </h1>
//           <p className="emp-dash__subtitle">
//             Health & compliance records vault
//           </p>
//         </div>
//         <div className="emp-dash__date-pill">
//           <FiFileText />
//           <span>
//             {new Date().toLocaleDateString("en-US", {
//               weekday: "short",
//               year: "numeric",
//               month: "short",
//               day: "numeric",
//             })}
//           </span>
//         </div>
//       </div>

//         {/* Notifications / Reminders */}
//         {notifications.length > 0 && (
//           <div className="emp-dash__card mb-6">
//             <div className="emp-dash__card-body bg-rose-50/50">
//               <div className="space-y-3">
//                 {notifications.map((note) => (
//                   <div key={note._id} className="bg-white border border-rose-100 p-4 rounded-2xl flex items-center gap-4 animate-pulse">
//                     <div className="p-2 bg-rose-600 text-white rounded-lg shadow-lg">
//                       <FiInfo size={14} />
//                     </div>
//                     <div className="flex-1">
//                       <p className="text-[11px] font-black text-rose-700 uppercase tracking-widest leading-tight">Administrative Alert</p>
//                       <p className="text-xs font-bold text-rose-900 mt-1">{note.message}</p>
//                     </div>
//                     <div className="text-[9px] font-bold text-rose-400 uppercase tracking-widest">
//                       {new Date(note.createdAt).toLocaleDateString()}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Upload Form */}
//         <div className="emp-dash__card mb-6">
//           <div className="emp-dash__card-header">
//             <div className="flex items-center gap-4">
//               <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-100 text-blue-600 flex items-center justify-center shadow-inner border border-blue-200/50">
//                 <FiUpload size={24} />
//               </div>
//               <div>
//                 <h3 className="emp-dash__card-title">Upload Certificate</h3>
//                 <p className="emp-dash__card-desc">Submit new medical certificate</p>
//               </div>
//             </div>
//           </div>
//           <div className="emp-dash__card-body bg-gray-50/50">
//             <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-4">
//           <div className="flex-1 min-w-[160px] space-y-2">
//             <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1.5 ml-1">
//               <FiCalendar className="text-blue-500" /> Registration Date
//             </label>
//             <input
//               type="date"
//               name="registrationDate"
//               value={formData.registrationDate}
//               onChange={handleInputChange}
//               className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none"
//               required
//             />
//           </div>

//           <div className="flex-1 min-w-[160px] space-y-2">
//             <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1.5 ml-1">
//               <FiCalendar className="text-red-400" /> Expiry Date
//             </label>
//             <input
//               type="date"
//               name="expiryDate"
//               value={formData.expiryDate}
//               onChange={handleInputChange}
//               className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none"
//               required
//             />
//           </div>

//           <div className="flex-1 min-w-[200px] space-y-2">
//             <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Upload Certificate</label>
//             <div className="relative">
//               <input
//                 type="file"
//                 onChange={handleFileChange}
//                 className="hidden"
//                 id="doc-upload"
//                 accept=".pdf,.jpg,.jpeg,.png"
//               />
//               <label
//                 htmlFor="doc-upload"
//                 className={`flex items-center gap-3 px-4 py-3 border-2 border-dashed rounded-xl transition-all cursor-pointer ${
//                   formData.document
//                     ? "border-blue-400 bg-blue-50/30"
//                     : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
//                 }`}
//               >
//                 <FiUpload className={`text-sm flex-shrink-0 ${formData.document ? "text-blue-500" : "text-gray-300"}`} />
//                 <span className="text-[10px] font-bold text-gray-600 uppercase tracking-widest truncate">
//                   {formData.document ? formData.document.name : "Choose File (PDF / Image)"}
//                 </span>
//               </label>
//             </div>
//           </div>

//           <div className="flex-shrink-0">
//             <button
//               type="submit"
//               disabled={uploading}
//               className="h-[46px] px-8 bg-indigo-600 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-indigo-100 hover:bg-indigo-700 transition-all active:scale-95 disabled:opacity-50 whitespace-nowrap flex items-center gap-2"
//             >
//               <FiUpload size={12} />
//               {uploading ? "Uploading..." : "Submit"}
//             </button>
//           </div>
//         </form>

//         {success && (
//           <div className="mt-4 p-4 bg-emerald-50 border border-emerald-100 rounded-2xl flex items-center gap-3">
//             <FiCheckCircle className="text-emerald-500 text-sm flex-shrink-0" />
//             <p className="text-[11px] font-bold text-emerald-700 uppercase tracking-widest">{success}</p>
//           </div>
//         )}
//         {error && (
//           <div className="mt-4 p-4 bg-red-50 border border-red-100 rounded-2xl flex items-center gap-3">
//             <FiXCircle className="text-red-500 text-sm flex-shrink-0" />
//             <p className="text-[11px] font-bold text-red-700 uppercase tracking-widest">{error}</p>
//           </div>
//         )}
//           </div>
//         </div>

//         {/* Records Table */}
//         <div className="emp-dash__card mb-6">
//           <div className="emp-dash__card-header">
//             <div className="flex items-center gap-4">
//               <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-100 text-blue-600 flex items-center justify-center shadow-inner border border-blue-200/50">
//                 <FiFileText size={24} />
//               </div>
//               <div>
//                 <h3 className="emp-dash__card-title">Certificate Records</h3>
//                 <p className="emp-dash__card-desc">View and manage your certificates</p>
//               </div>
//             </div>
//           </div>
//           <div className="emp-dash__card-body bg-gray-50/50">
//             <div className="overflow-x-auto">
//               <table className="min-w-[1000px]">
//                 <thead className="text-[11px] text-gray-700 uppercase tracking-widest font-bold border-b border-gray-200">
//                   <tr>
//                     <th className="py-4 px-6 text-left font-bold">Registration Date</th>
//                     <th className="py-4 px-6 text-left font-bold">Expiry Date</th>
//                     <th className="py-4 px-6 text-center font-bold">Validity Status</th>
//                     <th className="py-4 px-6 text-center font-bold">Document Access</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-50">
//                   {loading ? (
//                     <tr>
//                       <td colSpan={4} className="py-16 text-center">
//                         <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest animate-pulse">Loading Records...</p>
//                       </td>
//                     </tr>
//                   ) : certificates.length > 0 ? (
//                     certificates.map((cert) => {
//                       const isExpired = new Date(cert.expiryDate) < new Date();
//                       return (
//                         <tr key={cert._id} className="hover:bg-gray-50/50 transition-colors">
//                           <td className="py-4 px-6">
//                             <div className="flex flex-col">
//                               <span className="text-xs font-bold text-gray-800 uppercase tracking-tight">
//                                 {new Date(cert.registrationDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
//                               </span>
//                               <span className="text-[8px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">Issue Date</span>
//                             </div>
//                           </td>
//                           <td className="py-4 px-6">
//                             <div className="flex flex-col">
//                               <span className="text-xs font-bold text-gray-800 uppercase tracking-tight">
//                                 {new Date(cert.expiryDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
//                               </span>
//                               <span className="text-[8px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">Valid Until</span>
//                             </div>
//                           </td>
//                           <td className="py-4 px-6 text-center">
//                             {isExpired ? (
//                               <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-50 text-red-600 text-[10px] font-bold uppercase tracking-widest border border-red-100 shadow-sm">
//                                 <FiXCircle size={11} /> Expired
//                               </span>
//                             ) : (
//                               <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-[10px] font-bold uppercase tracking-widest border border-emerald-100 shadow-sm">
//                                 <FiCheckCircle size={11} /> Active
//                               </span>
//                             )}
//                           </td>
//                           <td className="py-4 px-6 text-center">
//                             <a
//                               href={`${API_DOMAIN}${cert.documentUrl}`}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="w-10 h-10 inline-flex items-center justify-center rounded-xl bg-indigo-50 text-indigo-700 hover:bg-indigo-600 hover:text-white border border-indigo-100 transition-all transform active:scale-90 shadow-sm"
//                               title="View Certificate"
//                             >
//                               <FiEye size={16} />
//                             </a>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan={4}>
//                         <div className="p-16 text-center">
//                           <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-4 text-blue-200 border border-blue-100/50 shadow-sm">
//                             <FiFileText size={30} />
//                           </div>
//                           <h3 className="text-base font-bold text-gray-700 mb-1">No Certificates Uploaded</h3>
//                           <p className="text-[11px] text-gray-400 font-bold tracking-widest uppercase max-w-xs mx-auto leading-relaxed">Use the form above to submit your first medical certificate for review.</p>
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="flex items-center justify-center gap-2 text-[9px] font-bold text-gray-400 uppercase tracking-widest py-4">
//           <FiShield className="text-blue-400" />
//           Timely Health Medical Records Vault • {new Date().getFullYear()}
//         </div>
//         </div>
    
//   );
// };

// export default MedicalCertificate;





import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiUpload, FiEye, FiCalendar, FiFileText, FiCheckCircle, FiXCircle, FiInbox, FiShield, FiInfo } from "react-icons/fi";
import { API_BASE_URL, API_DOMAIN } from "../utils/config";
import "./EmployeeDashboard.css";

// Mobile Card Component
const CertificateCard = ({ cert, API_DOMAIN }) => {
  const isExpired = new Date(cert.expiryDate) < new Date();
  
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-3 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-3">
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Registration Date</p>
          <p className="text-sm font-bold text-gray-800">
            {new Date(cert.registrationDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
          </p>
        </div>
        <div className="text-right">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Expiry Date</p>
          <p className="text-sm font-bold text-gray-800">
            {new Date(cert.expiryDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
          </p>
        </div>
      </div>
      
      <div className="flex justify-between items-center">
        <div>
          {isExpired ? (
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-50 text-red-600 text-[10px] font-bold uppercase tracking-widest border border-red-100 shadow-sm">
              <FiXCircle size={11} /> Expired
            </span>
          ) : (
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-[10px] font-bold uppercase tracking-widest border border-emerald-100 shadow-sm">
              <FiCheckCircle size={11} /> Active
            </span>
          )}
        </div>
        <a
          href={`${API_DOMAIN}${cert.documentUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 inline-flex items-center justify-center rounded-xl bg-indigo-50 text-indigo-700 hover:bg-indigo-600 hover:text-white border border-indigo-100 transition-all transform active:scale-90 shadow-sm"
          title="View Certificate"
        >
          <FiEye size={16} />
        </a>
      </div>
    </div>
  );
};

const MedicalCertificate = () => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [formData, setFormData] = useState({
    registrationDate: "",
    expiryDate: "",
    document: null,
  });

  const userRole = localStorage.getItem("userRole");
  const employeeData = JSON.parse(localStorage.getItem("employeeData"));
  
  let userId = "";
  let userName = "";
  let isCandidate = userRole === "candidate";

  if (isCandidate) {
    userId = localStorage.getItem("candidateId");
    userName = localStorage.getItem("candidateName");
  } else {
    userId = employeeData?.employeeId;
    userName = employeeData?.name;
  }

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (userId && userId !== "undefined" && userId !== "null") {
      fetchCertificates();
      fetchNotifications();
    } else {
      setError("");
    }
  }, [userId]);

  const fetchCertificates = async () => {
    try {
      setLoading(true);
      if (userId === "undefined" || userId === "null") return;
      const res = await axios.get(`${API_BASE_URL}/medical-certificates/employee/${userId}`);
      if (res.data.success) {
        setCertificates(res.data.data);
      }
    } catch (err) {
      console.error("Fetch certificates error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchNotifications = async () => {
    try {
      if (!userId || userId === "undefined" || userId === "null") return;
      const res = await axios.get(`${API_BASE_URL}/medical-certificates/notifications/${userId}`);
      if (res.data?.success) {
        setNotifications(res.data.data);
      }
    } catch (err) {
      // Silently ignore - notifications are non-critical
      setNotifications([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, document: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!userId || userId === "undefined" || userId === "null") {
      setError("Session expired or invalid user. Please login again.");
      return;
    }
    if (!formData.registrationDate || !formData.expiryDate || !formData.document) {
      setError("Please fill all fields and select a document.");
      return;
    }

    // Date validation - FIXED
    const registrationDate = new Date(formData.registrationDate);
    const expiryDate = new Date(formData.expiryDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Check 1: Registration date cannot be in the future
    if (registrationDate > today) {
      setError("Registration date cannot be in the future.");
      return;
    }

    // Check 2: Expiry date must be in the future
    if (expiryDate <= today) {
      setError("Expiry date must be in the future.");
      return;
    }

    // Check 3: Expiry date must be after registration date
    if (expiryDate <= registrationDate) {
      setError("Expiry date must be after registration date.");
      return;
    }

    // Calculate the difference in months between expiry and registration
    const monthsDiff = (expiryDate.getFullYear() - registrationDate.getFullYear()) * 12 +
                       (expiryDate.getMonth() - registrationDate.getMonth());

    // Check 4: Ensure at least 6 months difference between registration and expiry
    if (monthsDiff < 6) {
      setError(`Expiry date must be at least 6 months after registration date. (Current difference: ${monthsDiff} months)`);
      return;
    }

    // Optional: Check 5 - Maximum allowed difference is 24 months (2 years)
    // Remove this if you want to allow any duration
    if (monthsDiff > 24) {
      setError("Expiry date cannot be more than 24 months (2 years) after registration date.");
      return;
    }

    try {
      setUploading(true);

      const data = new FormData();
      if (isCandidate) {
        data.append("candidateId", userId);
        data.append("candidateName", userName);
      } else {
        data.append("employeeId", userId);
        data.append("employeeName", userName);
      }
      data.append("registrationDate", formData.registrationDate);
      data.append("expiryDate", formData.expiryDate);
      data.append("document", formData.document);

      const res = await axios.post(`${API_BASE_URL}/medical-certificates/upload`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        setSuccess("Medical certificate uploaded successfully!");
        setFormData({ registrationDate: "", expiryDate: "", document: null });
        // Reset file input
        const fileInput = document.getElementById('doc-upload');
        if (fileInput) fileInput.value = '';
        fetchCertificates();
        fetchNotifications();
      }
    } catch (err) {
      console.error("Upload error:", err);
      setError(err.response?.data?.message || "Failed to upload certificate.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="emp-dash__container">
      {/* Dashboard Header */}
      <div className="emp-dash__header">
        <div>
          <h1 className="emp-dash__greeting">
            Medical <span>Certificate</span>
          </h1>
          <p className="emp-dash__subtitle">
            Health & compliance records vault
          </p>
        </div>
        <div className="emp-dash__date-pill">
          <FiFileText />
          <span>
            {new Date().toLocaleDateString("en-US", {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </span>
        </div>
      </div>

      {/* Notifications / Reminders */}
      {notifications.length > 0 && (
        <div className="emp-dash__card mb-6">
          <div className="emp-dash__card-body bg-rose-50/50">
            <div className="space-y-3">
              {notifications.map((note) => (
                <div key={note._id} className="bg-white border border-rose-100 p-4 rounded-2xl flex flex-wrap items-center gap-4">
                  <div className="p-2 bg-rose-600 text-white rounded-lg shadow-lg">
                    <FiInfo size={14} />
                  </div>
                  <div className="flex-1 min-w-[150px]">
                    <p className="text-[11px] font-black text-rose-700 uppercase tracking-widest leading-tight">Administrative Alert</p>
                    <p className="text-xs font-bold text-rose-900 mt-1">{note.message}</p>
                  </div>
                  <div className="text-[9px] font-bold text-rose-400 uppercase tracking-widest">
                    {new Date(note.createdAt).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Upload Form */}
      <div className="emp-dash__card mb-6">
        <div className="emp-dash__card-header">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-100 text-blue-600 flex items-center justify-center shadow-inner border border-blue-200/50">
              <FiUpload size={24} />
            </div>
            <div>
              <h3 className="emp-dash__card-title">Upload Certificate</h3>
              <p className="emp-dash__card-desc">Submit new medical certificate</p>
            </div>
          </div>
        </div>
        <div className="emp-dash__card-body bg-gray-50/50">
          <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-4">
            <div className="flex-1 min-w-[160px] space-y-2">
              <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1.5 ml-1">
                <FiCalendar className="text-blue-500" /> Registration Date
              </label>
              <input
                type="date"
                name="registrationDate"
                value={formData.registrationDate}
                onChange={handleInputChange}
                max={new Date().toISOString().split('T')[0]}
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none"
                required
              />
              <p className="text-[8px] text-gray-400 ml-1">Any past date (must be before today)</p>
            </div>

            <div className="flex-1 min-w-[160px] space-y-2">
              <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1.5 ml-1">
                <FiCalendar className="text-red-400" /> Expiry Date
              </label>
              <input
                type="date"
                name="expiryDate"
                value={formData.expiryDate}
                onChange={handleInputChange}
                min={new Date(Date.now() + 86400000).toISOString().split('T')[0]}
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-blue-500 transition-all text-sm font-bold outline-none"
                required
              />
              <p className="text-[8px] text-gray-400 ml-1">Must be at least 6 months after registration</p>
            </div>

            <div className="flex-1 min-w-[200px] space-y-2">
              <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest ml-1">Upload Certificate</label>
              <div className="relative">
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="hidden"
                  id="doc-upload"
                  accept=".pdf,.jpg,.jpeg,.png"
                />
                <label
                  htmlFor="doc-upload"
                  className={`flex items-center gap-3 px-4 py-3 border-2 border-dashed rounded-xl transition-all cursor-pointer ${
                    formData.document
                      ? "border-blue-400 bg-blue-50/30"
                      : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
                  }`}
                >
                  <FiUpload className={`text-sm flex-shrink-0 ${formData.document ? "text-blue-500" : "text-gray-300"}`} />
                  <span className="text-[10px] font-bold text-gray-600 uppercase tracking-widest truncate">
                    {formData.document ? formData.document.name : "Choose File (PDF / Image)"}
                  </span>
                </label>
              </div>
            </div>

            <div className="flex-shrink-0 w-full sm:w-auto">
              <button
                type="submit"
                disabled={uploading}
                className="w-full sm:w-auto h-[46px] px-8 bg-indigo-600 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-indigo-100 hover:bg-indigo-700 transition-all active:scale-95 disabled:opacity-50 whitespace-nowrap flex items-center justify-center gap-2"
              >
                <FiUpload size={12} />
                {uploading ? "Uploading..." : "Submit"}
              </button>
            </div>
          </form>

          {success && (
            <div className="mt-4 p-4 bg-emerald-50 border border-emerald-100 rounded-2xl flex items-center gap-3">
              <FiCheckCircle className="text-emerald-500 text-sm flex-shrink-0" />
              <p className="text-[11px] font-bold text-emerald-700 uppercase tracking-widest">{success}</p>
            </div>
          )}
          {error && (
            <div className="mt-4 p-4 bg-red-50 border border-red-100 rounded-2xl flex items-center gap-3">
              <FiXCircle className="text-red-500 text-sm flex-shrink-0" />
              <p className="text-[11px] font-bold text-red-700 uppercase tracking-widest">{error}</p>
            </div>
          )}
        </div>
      </div>

      {/* Records Table */}
      <div className="emp-dash__card mb-6">
        <div className="emp-dash__card-header">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-100 text-blue-600 flex items-center justify-center shadow-inner border border-blue-200/50">
              <FiFileText size={24} />
            </div>
            <div>
              <h3 className="emp-dash__card-title">Certificate Records</h3>
              <p className="emp-dash__card-desc">View and manage your certificates</p>
            </div>
          </div>
        </div>
        <div className="emp-dash__card-body bg-gray-50/50">
          {/* Desktop Table - Hidden on mobile */}
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-[1000px]">
              <thead className="text-[11px] text-gray-700 uppercase tracking-widest font-bold border-b border-gray-200">
                <tr>
                  <th className="py-4 px-6 text-left font-bold">Registration Date</th>
                  <th className="py-4 px-6 text-left font-bold">Expiry Date</th>
                  <th className="py-4 px-6 text-center font-bold">Validity Status</th>
                  <th className="py-4 px-6 text-center font-bold">Document Access</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {loading ? (
                  <tr>
                    <td colSpan={4} className="py-16 text-center">
                      <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest animate-pulse">Loading Records...</p>
                    </td>
                  </tr>
                ) : certificates.length > 0 ? (
                  certificates.map((cert) => {
                    const isExpired = new Date(cert.expiryDate) < new Date();
                    return (
                      <tr key={cert._id} className="hover:bg-gray-50/50 transition-colors">
                        <td className="py-4 px-6">
                          <div className="flex flex-col">
                            <span className="text-xs font-bold text-gray-800 uppercase tracking-tight">
                              {new Date(cert.registrationDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                            </span>
                            <span className="text-[8px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">Issue Date</span>
                          </div>
                        </td>
                        <td className="py-4 px-6">
                          <div className="flex flex-col">
                            <span className="text-xs font-bold text-gray-800 uppercase tracking-tight">
                              {new Date(cert.expiryDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                            </span>
                            <span className="text-[8px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">Valid Until</span>
                          </div>
                        </td>
                        <td className="py-4 px-6 text-center">
                          {isExpired ? (
                            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-50 text-red-600 text-[10px] font-bold uppercase tracking-widest border border-red-100 shadow-sm">
                              <FiXCircle size={11} /> Expired
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-[10px] font-bold uppercase tracking-widest border border-emerald-100 shadow-sm">
                              <FiCheckCircle size={11} /> Active
                            </span>
                          )}
                        </td>
                        <td className="py-4 px-6 text-center">
                          <a
                            href={`${API_DOMAIN}${cert.documentUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-10 h-10 inline-flex items-center justify-center rounded-xl bg-indigo-50 text-indigo-700 hover:bg-indigo-600 hover:text-white border border-indigo-100 transition-all transform active:scale-90 shadow-sm"
                            title="View Certificate"
                          >
                            <FiEye size={16} />
                          </a>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4}>
                      <div className="p-16 text-center">
                        <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-4 text-blue-200 border border-blue-100/50 shadow-sm">
                          <FiFileText size={30} />
                        </div>
                        <h3 className="text-base font-bold text-gray-700 mb-1">No Certificates Uploaded</h3>
                        <p className="text-[11px] text-gray-400 font-bold tracking-widest uppercase max-w-xs mx-auto leading-relaxed">Use the form above to submit your first medical certificate for review.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards - Visible on mobile only */}
          <div className="md:hidden">
            {loading ? (
              <div className="py-10 text-center">
                <p className="text-[11px] font-bold text-gray-400 uppercase tracking-widest animate-pulse">Loading Records...</p>
              </div>
            ) : certificates.length > 0 ? (
              <div className="p-4">
                {certificates.map((cert) => (
                  <CertificateCard key={cert._id} cert={cert} API_DOMAIN={API_DOMAIN} />
                ))}
              </div>
            ) : (
              <div className="p-16 text-center">
                <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-4 text-blue-200 border border-blue-100/50 shadow-sm">
                  <FiFileText size={30} />
                </div>
                <h3 className="text-base font-bold text-gray-700 mb-1">No Certificates Uploaded</h3>
                <p className="text-[11px] text-gray-400 font-bold tracking-widest uppercase max-w-xs mx-auto leading-relaxed">Use the form above to submit your first medical certificate for review.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-center gap-2 text-[9px] font-bold text-gray-400 uppercase tracking-widest py-4">
        <FiShield className="text-blue-400" />
        Timely Health Medical Records Vault • {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default MedicalCertificate;